import { render, staticRenderFns } from "./PostNavBtn.vue?vue&type=template&id=afa932a4&scoped=true&"
import script from "./PostNavBtn.vue?vue&type=script&lang=js&"
export * from "./PostNavBtn.vue?vue&type=script&lang=js&"
import style0 from "./PostNavBtn.vue?vue&type=style&index=0&id=afa932a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa932a4",
  null
  
)

export default component.exports